import React, { useCallback, useMemo, useEffect, useState } from 'react';
import { Col, Row, Pagination } from 'antd';
import styles from './index.less';
import GeneralLayout from '../../../layouts/general';
import { CommonSectionLayout } from 'src/components/POSWebsite/legacy';
import { JoinClassName } from 'src/utils/utils';
import { useRouter } from 'next/router';
import PreviewArticleCard from '../PreviewArticleCard';
import Link from 'next/link';
import { getArticles, fetchDataByLocale } from '../../../server-services/contentful';
import { CONTENTFUL_LOCAL_EN, CONTENTFUL_LOCAL_ZH } from 'src/utils/contentful';
import cookie from 'cookie';
import { FormattedMessage, useIntl } from 'react-intl';
import useLocale from 'src/hooks/useLocale';

const PAGE_SIZE = 5;
const BlogPage = ({ articles: _articles_, total, totalPages, defualtLang }) => {
  const intl = useIntl();
  const router = useRouter();
  const locale = useLocale();
  const page = router.query.page;

  const onPaginationChange = useCallback((page) => {
    router.push('/blog/all/[page]', `/blog/all/${page}`);
  }, []);

  const { articles } = useMemo(() => {
    let contentfulLocale = CONTENTFUL_LOCAL_EN;
    if (locale === 'en') {
      contentfulLocale = CONTENTFUL_LOCAL_EN;
    } else {
      contentfulLocale = CONTENTFUL_LOCAL_ZH;
    }

    return {
      articles: _articles_.map((article) => {
        return article[contentfulLocale];
      }),
    };
  }, [locale, _articles_]);

  const pageFeaturedImage =
    articles && articles[0] ? (articles[0].fields?.featureImage || null)?.fields.file.url || '' : '';

  return (
    <GeneralLayout
      pageClass="blog-page full-width-page"
      pageTitle={'POS Blogs | Chowbus POS'}
      pageFeaturedImage={pageFeaturedImage}
    >
      <div className={JoinClassName(styles.PageBlog)}>
        <div className={JoinClassName(styles.allArticles)}>
          <CommonSectionLayout backgroundColor="#ffffff" title={''} description={''}>
            <div className={JoinClassName(styles.backBlogHome)}>
              <Link href="/blog">
                <a> {`< ${intl.formatMessage({ id: 'home.blog.backbloghome' })}`}</a>
              </Link>
            </div>
            {articles && (
              <Row gutter={[{ xs: 0, sm: 16, md: 16 }, 16]}>
                {articles.map((article, index) => {
                  return (
                    <Col key={index} xs={24}>
                      <PreviewArticleCard article={article} showPreview={true} />
                    </Col>
                  );
                })}
              </Row>
            )}
            {totalPages > 1 && (
              <div className={JoinClassName(styles.paginationBottom)}>
                <Pagination
                  current={Number.parseInt(page)}
                  pageSize={PAGE_SIZE}
                  onChange={onPaginationChange}
                  total={total}
                  itemRender={(_, type, originalElement) => {
                    if (type === 'page') {
                      return (
                        <Link href={`/blog/all/${_}`}>
                          <a>{_}</a>
                        </Link>
                      );
                    }
                    return originalElement;
                  }}
                />
              </div>
            )}
          </CommonSectionLayout>
        </div>
      </div>
    </GeneralLayout>
  );
};

export async function getServerSideProps(context) {
  const { params, req, locale } = context;
  const cookies = cookie.parse(req ? req.headers.cookie || '' : '');
  const defualtLang = cookies['pos.locale'] || 'en';
  let articles = null;
  try {
    articles = await getArticles({ page: Number.parseInt(params.page) });
  } catch (error) {
    console.log(error);
  }
  let articleItems = (articles ? articles.items : []).map(fetchDataByLocale).filter((item) => !!item);
  if (!articles || articleItems.length === 0) {
    return {
      redirect: {
        destination: '/blog',
        permanent: false,
      },
    };
  }

  return {
    props: {
      articles: (articles ? articles.items : []).map(fetchDataByLocale).filter((item) => !!item),
      total: articles ? articles.total : 0,
      totalPages: articles ? articles.totalPages : 0,
      defualtLang,
    },
  };
}

export default BlogPage;
